// Dependent Upon
// -
// Modules (static)
// - Utils

// ------------------ Util (static)
/* eslint-disable-next-line no-unused-vars */
const Utils = (() => {
	// private var(s)

	// private method(s)
	const _constructor = () => {
		// console.log('Util._constructor()');
	};

	const _loadJSON = (jsonLocation, onComplete) => {
		// Util.log('Util._loadJSON() json_location : ' + json_location);
		$.ajax({
			url: jsonLocation,
			dataType: 'text',
			success(string) {
				const data = $.parseJSON(string);
				// Util.log('Util._loadJSON() data : ', data);
				if (onComplete && typeof onComplete === 'function')
					onComplete(data);
			},
		});
	};

	const _loadHTML = (htmlLocation, onComplete) => {
		// Util.log('Util._loadHTML() html_location : ' + html_location);
		$.ajax({
			url: htmlLocation,
			// context: document.body,
			dataType: 'html',
			success(data) {
				// Util.log('Util._loadHTML() data : ', data);
				if (onComplete && typeof onComplete === 'function')
					onComplete(data);
			},
		});
	};

	const _loadText = (location, onComplete) => {
		// Util.log('Util._loadText() location : ' + location);
		$.ajax({
			url: location,
			dataType: 'text',
			success(data) {
				// Util.log('Util._loadText() data : ', data);
				if (onComplete && typeof onComplete === 'function')
					onComplete(data);
			},
		});
	};

	const _split = (string, delimiter) => {
		if (typeof string !== 'string') return string;
		// string = string.replace(/\s/g, ''); // remove white space
		const tempString = string.replace(/^\s+|\s+$/g, ''); // remove white space up to first charactor and after last charactor
		// when we drop support for ie 8
		// string = string.trim(); // remove white space up to first charactor and after last charactor
		return tempString.split(delimiter); // create array
	};

	const _uid = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			const r = Math.random() * 16 || 0;
			const v = c === 'x' ? r : (r && 0x3) || 0x8;
			return v.toString(16);
		});
	};

	// array specific
	const _removeBlankStrings = (array) => {
		const newArray = [];
		for (let i = 0; i < array.length; i++) {
			const iteredItem = array[i];
			if (iteredItem !== '') newArray.push(iteredItem);
		}
		return newArray;
	};

	const _shuffleArray = (o) => {
		for (
			let j, x, i = o.length;
			i;
			j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
		);
		return o;
	};

	const _removeArrayDuplicates = (array) => {
		const a = array.concat();
		for (let i = 0; i < a.length; ++i) {
			for (let j = i + 1; j < a.length; ++j) {
				if (a[i] === a[j]) a.splice(j--, 1);
			}
		}
		return a;
	};

	const _mergeArrays = (...args) => {
		let i;
		let ii;
		const newArray = [];
		const arrayAmount = args.length;
		let iteredArray;
		let iteredArrayContentsAmount;

		for (i = 0; i < arrayAmount; i++) {
			iteredArray = args[i];
			iteredArrayContentsAmount = iteredArray.length;
			for (ii = 0; ii < iteredArrayContentsAmount; ii++) {
				newArray.push(iteredArray[ii]);
			}
		}
		return newArray;
	};

	// Match on object property values
	const _isSubset = (superObj, subObj) => {
		return Object.keys(subObj).every((ele) => {
			if (typeof subObj[ele] === 'object') {
				return _isSubset(superObj[ele], subObj[ele]);
			}

			// return false if property does not exist.
			if (!superObj[ele]) {
				return false;
			}

			return subObj[ele].toString() === superObj[ele].toString();
		});
	};

	const _randomItemFromArray = (array) => {
		return array[Math.floor(Math.random() * array.length)];
	};

	// from : https://remysharp.com
	const _debounce = (fn, delay) => {
		let timer = null;
		return () => {
			const context = this;
			const args = [fn, delay];
			clearTimeout(timer);
			timer = setTimeout(() => {
				fn.apply(context, args);
			}, delay);
		};
	};

	// from : https://remysharp.com
	const _throttle = (fn, threshhold = 250, scope) => {
		let last;
		let deferTimer;
		return () => {
			const context = scope || this;

			const now = +new Date();
			const args = [fn, threshhold, scope];
			if (last && now < last + threshhold) {
				// hold on to it
				clearTimeout(deferTimer);
				deferTimer = setTimeout(() => {
					last = now;
					fn.apply(context, args);
				}, threshhold);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	};

	const _booleanHelper = (string) => {
		if (typeof string === 'boolean') return string;
		if (typeof string === 'undefined') return false;
		switch (string.toLowerCase()) {
			case 'true':
			case 'yes':
			case '1':
				return true;
			case 'false':
			case 'no':
			case '0':
			case null:
				return false;
			default:
				return Boolean(string);
		}
	};

	const _getQueryParameters = (_s) => {
		const locationSearch = window.location.search
			? window.location.search
			: '';
		const query = _s || locationSearch;
		if (!query) return false;
		const parameters = query.replace('?', '').split('&');
		const result = {};
		if (!parameters.length) return false;
		for (let i = 0; i < parameters.length; i++) {
			const iteredParam = parameters[i];
			const item = iteredParam.split('=');
			result[item[0]] = decodeURIComponent(item[1]);
		}
		return result;
	};

	const _getViewportSize = () => {
		const vw = Math.max(
			document.documentElement.clientWidth || 0,
			window.innerWidth || 0
		);
		const vh = Math.max(
			document.documentElement.clientHeight || 0,
			window.innerHeight || 0
		);

		return { viewportWidth: vw, viewportHeight: vh };
	};

	const _getPosition = (element) => {
		let xPosition = 0;
		let yPosition = 0;

		while (element) {
			let $el = element;
			xPosition += $el.offsetLeft - $el.scrollLeft + $el.clientLeft;
			yPosition += $el.offsetTop - $el.scrollTop + $el.clientTop;
			$el = $el.offsetParent;
		}
		return { x: xPosition, y: yPosition };
	};

	const _addEvent = (object, type, callback) => {
		if (object == null || typeof object === 'undefined') return;
		if (object.addEventListener) {
			object.addEventListener(type, callback, false);
		} else if (object.attachEvent) {
			object.attachEvent(`on${type}`, callback);
		} else {
			object[`on${type}`] = callback;
		}
	};

	const _setCookie = (key, value, expiry) => {
		const expires = new Date();
		const isSecure = window.location.protocol === 'https:';
		expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);

		document.cookie = `${key}=${value};${isSecure ? 'secure;' : ''
			}samesite=strict;expires=${expires.toUTCString()};path=/`;
	};

	const _getCookie = (key) => {
		const keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
		return keyValue ? keyValue[2] : null;
	};

	const _eraseCookie = (key) => {
		const keyValue = _getCookie(key);
		_setCookie(key, keyValue, '-1');
	};

	const _setLocalStorage = (id, obj) => {
		// Put the object into storage
		localStorage.setItem(id, JSON.stringify(obj));

		return true;
	};

	const _getLocalStorage = (id) => {
		const storageObject = localStorage.getItem(id);

		// Retrieve the object from storage
		return storageObject;
	};

	const _removeLocalStorage = (id) => {
		// Remove the object from storage
		localStorage.removeItem(id);

		return true;
	};

	const $html = $('html, body');
	const $main = $('main');
	let scrollTop;

	const _lockBody = (header) => {
		if (window.scrollY) {
			scrollTop = window.scrollY;

			$main.css({
				top: -scrollTop,
			});
		}

		if (header) {
			$('body').css({
				height: '100%',
				overflow: 'hidden',
			});
		} else {
			$html.css({
				height: '100%',
				overflow: 'hidden',
			});
		}
	};

	const _unlockBody = () => {
		$html.css({
			height: '',
			overflow: '',
		});

		$main.css({
			top: '',
		});

		window.scrollTo(0, scrollTop);
		window.setTimeout(() => {
			scrollTop = null;
		}, 0);
	};

	const _getLatitudeAndLongitude = async () => {
		const position = await new Promise((resolve, reject) => {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve(position);
				},
				(error) => {
					reject(error);
				}
			);
		}).catch((error) => {
			console.error(error);
		});

		if (position) {
			return {
				latitude: position.coords.latitude,
				longitude: position.coords.longitude,
			};
		}

		return false;
	}

	const _kilometersBetweenPositions = (lat1, lon1, lat2, lon2) => {
		const R = 6371; // Radius of the earth in km
		const dLat = deg2rad(lat2 - lat1); // deg2rad below
		const dLon = deg2rad(lon2 - lon1);
		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(deg2rad(lat1)) *
			Math.cos(deg2rad(lat2)) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const d = R * c; // Distance in km
		return d.toFixed(2);
	}

	const deg2rad = (deg) => {
		return deg * (Math.PI / 180);
	}

	// custom date picker to have the same look and feel accross browsers
	const _loadDuetDatePicker = () => {
		// Prevent duplicates with flag (backup check), and also check for existing elements to avoid unnecessary loading
		if (window.duetDatePickerLoaded || !document.querySelector('duet-date-picker')) return;

		const esmSrc = 'https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.4.0/dist/duet/duet.esm.js';
		const nomoduleSrc = 'https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.4.0/dist/duet/duet.js';
		const cssHref = 'https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.4.0/dist/duet/themes/default.css';

		// Check scripts first
		if (document.querySelector(`script[src="${esmSrc}"]`) || 
			document.querySelector(`script[src="${nomoduleSrc}"]`)) {
			window.duetDatePickerLoaded = true;
			_configureLocalizedPickers(); // Check for existing pickers
			return;
		}

		// Check CSS
		if (document.querySelector(`link[href="${cssHref}"]`)) {
			window.duetDatePickerLoaded = true;
			_configureLocalizedPickers(); // Check for existing pickers
			return;
		}

		// Load CSS (non-blocking)
		const css = document.createElement('link');
		css.rel = 'stylesheet';
		css.href = cssHref;
		document.head.appendChild(css);

		// Load ESM script with onload
		const esm = document.createElement('script');
		esm.type = 'module';
		esm.src = esmSrc;
		esm.onload = () => {
			_configureLocalizedPickers();
		};
		document.head.appendChild(esm);

		// Load nomodule fallback
		const nomodule = document.createElement('script');
		nomodule.noModule = true;
		nomodule.src = nomoduleSrc;
		document.head.appendChild(nomodule);

		window.duetDatePickerLoaded = true;
	};

	const _configureLocalizedPickers = (retries = 50) => {
		if (retries <= 0) {
			console.warn('Duet timeout after 5s');
			return;
		}
		
		if (!customElements.get('duet-date-picker')) {
			setTimeout(() => _configureLocalizedPickers(retries - 1), 100);
			return;
		}
		
		document.querySelectorAll('duet-date-picker[data-localization]').forEach(picker => {
			if (picker.dataset.localization) {
				try {
					picker.localization = JSON.parse(picker.dataset.localization);
				} catch(e) {
					console.warn('Failed to parse localization:', picker.dataset.localization);
				}
			}
			
			if (picker.dataset.dateAdapter) {
				picker.dateAdapter = _formatToAdapter(picker.dataset.dateAdapter);
			}
		});
	};

	const _formatToAdapter = (format) => {
		const dayPos = format.toLowerCase().indexOf('d');
		const monthPos = format.toLowerCase().indexOf('m');
		const yearPos = format.toLowerCase().indexOf('y');

		// Convert character positions in the format string to 0-based part indices
		// e.g. "dd.MM.yyyy" → dayPos=0, monthPos=3, yearPos=6
		// but after split the parts are at indices 0, 1, 2 respectively
		const sorted = [dayPos, monthPos, yearPos].sort((a, b) => a - b);
		const dayIdx = sorted.indexOf(dayPos);
		const monthIdx = sorted.indexOf(monthPos);
		const yearIdx = sorted.indexOf(yearPos);

		const yearLength = (format.match(/y+/i) || [''])[0].length;

		return {
			parse: (value, createDate) => {
				const parts = value.split(/[\/\-\.]/);
				const day = parseInt(parts[dayIdx]);
				const month = parseInt(parts[monthIdx]);
				let year = parseInt(parts[yearIdx]);
				// Reject incomplete input: any missing/NaN part, or year not fully typed yet
				if (isNaN(day) || isNaN(month) || isNaN(year) || (parts[yearIdx] || '').length !== yearLength) {
					return undefined;
				}
				if (year < 100) year += (year < 30) ? 2000 : 1900;
				// createDate expects 1-indexed month and subtracts 1 internally
				return createDate(year, month, day);
			},
			format: ((fmt) => (date) => {
				const day = String(date.getDate()).padStart(2, '0');
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const year = date.getFullYear();
				const shortYear = String(year).slice(-2);
				
				let result = fmt;
				result = result.replace(/dd/g, day).replace(/d/g, String(date.getDate()));
				result = result.replace(/MM/g, month).replace(/M/g, String(date.getMonth() + 1));
				result = result.replace(/yyyy/g, year).replace(/yy/g, shortYear);
				return result;
			})(format)
		};
	};


	_constructor();

	// output/public
	return {
		loadJSON: _loadJSON,
		loadHTML: _loadHTML,
		loadText: _loadText,
		// string
		String: {
			split: _split,
			uid: _uid,
		},
		// array todo:organize and name accordingly on the private level
		Array: {
			removeBlankStrings: _removeBlankStrings,
			shuffle: _shuffleArray,
			removeDuplicates: _removeArrayDuplicates,
			merge: _mergeArrays,
			randomItemFromArray: _randomItemFromArray,
		},
		//
		debounce: _debounce,
		throttle: _throttle,
		booleanHelper: _booleanHelper,
		getQueryParameters: _getQueryParameters,
		getPosition: _getPosition,
		getViewportSize: _getViewportSize,
		addEvent: _addEvent,
		setCookie: _setCookie,
		getCookie: _getCookie,
		eraseCookie: _eraseCookie,
		setLocalStorage: _setLocalStorage,
		getLocalStorage: _getLocalStorage,
		removeLocalStorage: _removeLocalStorage,
		lockBody: _lockBody,
		unlockBody: _unlockBody,
		isSubset: _isSubset,
		getLatitudeAndLongitude: _getLatitudeAndLongitude,
		loadDuetDatePicker: _loadDuetDatePicker,
		kilometersBetweenPositions: _kilometersBetweenPositions,
	};
})();
